/**
 * Installation-level channel catalog + Messenger OAuth scope helpers.
 * Flags come from window.globalConfig (DashboardController app_config merge).
 */

const KEYS = {
  INCLUDE_IG_SCOPES: 'MESSENGER_OAUTH_INCLUDE_INSTAGRAM_SCOPES',
  WHATSAPP_VISIBLE: 'INBOX_CHANNEL_WHATSAPP_VISIBLE',
  INSTAGRAM_VISIBLE: 'INBOX_CHANNEL_INSTAGRAM_VISIBLE',
};

// pages_read_engagement rejected in App Review and unused by Messenger inbox
// connect (REQ-20260823-01).
const MESSENGER_BASE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
];

const INSTAGRAM_OAUTH_SCOPES = [
  'instagram_basic',
  'instagram_manage_messages',
];

const readFlag = (key, defaultValue) => {
  try {
    const raw = window.globalConfig?.[key];
    if (raw === undefined || raw === null || raw === '') return defaultValue;
    if (typeof raw === 'boolean') return raw;
    if (typeof raw === 'string') {
      const normalized = raw.trim().toLowerCase();
      if (['true', '1', 'yes'].includes(normalized)) return true;
      if (['false', '0', 'no'].includes(normalized)) return false;
    }
    return Boolean(raw);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.debug('[channel_catalog] flag read failed', { key, error: error?.message });
    return defaultValue;
  }
};

export const messengerOauthIncludeInstagramScopes = () =>
  readFlag(KEYS.INCLUDE_IG_SCOPES, false);

export const isInboxChannelWhatsappVisible = () =>
  readFlag(KEYS.WHATSAPP_VISIBLE, true);

export const isInboxChannelInstagramVisible = () =>
  readFlag(KEYS.INSTAGRAM_VISIBLE, true);

/** Returns false when the catalog deliberately hides this Add-Inbox channel. */
export const isInboxChannelVisible = channelKey => {
  if (channelKey === 'whatsapp') return isInboxChannelWhatsappVisible();
  if (channelKey === 'instagram') return isInboxChannelInstagramVisible();
  return true;
};

export const messengerOauthScopeString = () => {
  const scopes = [...MESSENGER_BASE_SCOPES];
  const includeIg = messengerOauthIncludeInstagramScopes();
  if (includeIg) scopes.push(...INSTAGRAM_OAUTH_SCOPES);
  // eslint-disable-next-line no-console
  console.debug('[channel_catalog] messenger oauth scopes', {
    includeInstagramScopes: includeIg,
    scopeCount: scopes.length,
  });
  return scopes.join(',');
};
